import React from 'react';

const OutlierToggleSkeleton = () => {
  return (
    <div className="flex flex-col items-center justify-center">
      {/* Skeleton for Checkbox */}
      <div className="inline-flex items-center my-auto">
        <div className="animate-pulse flex space-x-2">
          {/* Simulated checkbox */}
          <div className="h-5 w-5 bg-gray-200 rounded"></div>
          {/* Placeholder for label text */}
          <div className="h-5 bg-gray-200 rounded w-24"></div>
        </div>
      </div>
    </div>
  )
}

export default OutlierToggleSkeleton;

